"use strict";
//-----------------------------------------------------------------------------
// This  file handles the authentication to the OAuth Provider
//-----------------------------------------------------------------------------
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
exports.getAuthenticator = exports.AuthenticationHelper = void 0;
/***
  @singleton decorator
  add static method getInstance(...args) to decorated class which returns single instance
  (or constructs single instance if it doesn't exist)
  
***/
function singleton(Target) {
    //static instance getter method
    Target.getInstance = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // save a reference to the original constructor
        var original = Target;
        // a utility function to generate instance of a class
        function construct(constructor) {
            var c = function () {
                return constructor.apply(this, args);
            };
            c.prototype = constructor.prototype;
            return new c();
        }
        //new constructor
        var f = function () {
            return construct(original);
        };
        if (!original.instance) {
            // copy prototype so intanceof operator still works
            f.prototype = original.prototype;
            original.instance = new f();
        }
        return original.instance;
    };
}
// Just mock these up for the moment so that we have something
// to call
var AuthenticationHelper = /** @class */ (function () {
    // We need to make this private so that others cannot use it
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    function AuthenticationHelper() {
        this.isAuthenticatedNow = false;
        this.authToken = '';
        this.refreshToken = '';
    }
    AuthenticationHelper.getInstance = function () {
        return undefined;
    };
    AuthenticationHelper.prototype.isAuthenticated = function () {
        return this.isAuthenticatedNow;
    };
    AuthenticationHelper.prototype.authenticate = function (user, password) {
        this.isAuthenticatedNow = this.hasValue(user) && this.hasValue(password);
        this.authToken = 'I.Am.A.AuthToken';
        this.refreshToken = 'I.Am.A.RefreshToken';
        return this.isAuthenticatedNow;
    };
    AuthenticationHelper.prototype.hasValue = function (str) {
        return str !== undefined && str !== null && str !== '';
    };
    AuthenticationHelper = __decorate([
        singleton
    ], AuthenticationHelper);
    return AuthenticationHelper;
}());
exports.AuthenticationHelper = AuthenticationHelper;
// Use this function to get the Instance of the class
function getAuthenticator() {
    return AuthenticationHelper.getInstance();
}
exports.getAuthenticator = getAuthenticator;
